/**
 * JS-1396 — framework-free helpers for the one-time recovery-codes reveal.
 *
 * Shared by SecurityTabComponent (regenerating codes from the Security tab)
 * and PasskeyEnrolComponent (the mandatory first-enrolment screen): both
 * dialogs show the same codes, the same way, so the clipboard/file mechanics
 * live here once instead of twice. The success toast stays with each caller,
 * since they phrase it through their own injected translate/message
 * services - that wiring is Angular, so it does not belong in here.
 */

export function copyCodesToClipboard(codes: string[]): void {
  const textarea = document.createElement('textarea');
  textarea.value = codes.join('\n');
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}

export function downloadCodesAsFile(codes: string[]): void {
  const blob = new Blob([codes.join('\n')], { type: 'text/plain' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'job-rocks-recovery-codes.txt';
  link.click();
  URL.revokeObjectURL(link.href);
}
